import * as THREE from 'three';
import { mergeGeometries } from 'three/addons/utils/BufferGeometryUtils.js';

// ---------------------------------------------------------------------------
// Static scenery, welded into one mesh.
//
// Draw calls are what a phone runs out of, not triangles: a scene of a hundred
// small objects is slower than one object with a hundred times the geometry.
// Two dozen marker posts and a moored fishing fleet never move, so they have
// no business being two dozen separate draws.
// ---------------------------------------------------------------------------

/**
 * @param objects things already placed in the world — position and rotation
 *   are baked in, so they must be final before this is called
 * @returns a single Mesh, or null if there was nothing to weld
 */
export function weld(objects, material, name = 'welded') {
    const parts = [];
    for (const object of objects) {
        object.updateMatrixWorld(true);
        object.traverse((o) => {
            if (!o.isMesh || !o.geometry) return;
            const g = o.geometry.clone();
            g.applyMatrix4(o.matrixWorld);
            parts.push(g);
        });
    }
    if (!parts.length) return null;

    const merged = mergeGeometries(parts, false);
    for (const g of parts) g.dispose();
    if (!merged) return null;

    const mesh = new THREE.Mesh(merged, material);
    mesh.name = name;
    return mesh;
}
